import { Zone, ZoneStatus } from '../../shared/types'
import { Button } from '../common'
import useZoneAdverts from './useZoneAdverts'
import { STORAGE_URL } from '../../shared/constants/env'
import { BodyContent } from '../content'
import { hasContent } from '../../shared/utils'
import styles from './ZoneAdverts.module.scss'
import { Copy, CopyContainer } from '../common/copy'
import { Typography } from '@mui/material'

const ZoneAdverts = () => {
  const { data, loading, error, disabledZoneId, handlers } = useZoneAdverts()
  const { handleGoToZoneIntro, handleShowDisabledOverlay } = handlers

  return (
    <div className={styles.zoneAdvertsRoot}>
      <div className={`white-block ${styles.capitolNoirBanner}`}>
        CAPITOL&nbsp;NOIR
      </div>

      {data?.map((zone: Zone) => {
        const zoneId = zone.id
        const onlyOneAdvert = data?.length === 1
        const hasAdvert = hasContent(zone?.advert)

        return (
          <div key={zoneId} className={styles.advert}>
            {zone.status === ZoneStatus.Enabled ? (
              // ENABLED zones
              <Button
                variant="text"
                onClick={() => handleGoToZoneIntro(zoneId)}
              >
                {hasAdvert ? (
                  // Has advert
                  <>
                    <BodyContent
                      filePath={`${STORAGE_URL}zones/${zoneId}/advert/`}
                      contentBlock={zone.advert}
                    />
                    {/* Show the advert twice if there is only one advert */}
                    {onlyOneAdvert && (
                      <BodyContent
                        filePath={`${STORAGE_URL}zones/${zoneId}/advert/`}
                        contentBlock={zone.advert}
                      />
                    )}
                  </>
                ) : (
                  // No advert
                  <div className={styles.noImgEnabled}>
                    <CopyContainer padding="large" leftRight={true}>
                      <Copy>
                        <Typography variant="h1">
                          {zone?.name || zoneId}
                        </Typography>
                        <Typography variant="h3">{zone?.subTitle}</Typography>
                      </Copy>
                    </CopyContainer>
                  </div>
                )}
              </Button>
            ) : (
              // DISABLED zones
              <div
                className={styles.disabledWrapper}
                onClick={() => handleShowDisabledOverlay(zoneId)}
              >
                {hasAdvert ? (
                  // Has advert
                  <BodyContent
                    filePath={`${STORAGE_URL}zones/${zoneId}/advert/`}
                    contentBlock={zone.advert}
                  />
                ) : (
                  // No advert
                  <div
                    className={`${styles.noImgDisabled} ${styles.disabledWrapper}`}
                    onClick={() => handleShowDisabledOverlay(zoneId)}
                  >
                    <CopyContainer padding="large" leftRight={true}>
                      <Copy>
                        <Typography variant="h1">
                          {zone?.name || zoneId}
                        </Typography>
                        <Typography variant="h3">{zone?.subTitle}</Typography>
                      </Copy>
                    </CopyContainer>
                  </div>
                )}
                {disabledZoneId === zoneId && (
                  <div className={styles.disabledOverlay}>
                    <Typography variant="block">Coming Soon!</Typography>
                  </div>
                )}
              </div>
            )}
          </div>
        )
      })}

      <div className={`white-block mirror-text ${styles.capitolNoirBanner}`}>
        L&nbsp;NOIR&nbsp;CAPITOL
      </div>
    </div>
  )
}

export default ZoneAdverts
